import React, { ReactNode } from "react";
import { SecondaryButton } from "Shared/Buttons";

const BlockContainer = ({ children, icon }: { children: ReactNode; icon: ReactNode }) => {
    return (
        <div className={`ContinueDealerOffer__Block`}>
            <div className={`ContinueDealerOffer__Block__Icon`}>{icon}</div>
            <div className={`ContinueDealerOffer__Block__Content`}>{children}</div>
        </div>
    );
};

const BlockHeader = ({ children }: { children: ReactNode }) => {
    return <div className={`ContinueDealerOffer__Block__Header`}>{children}</div>;
};

const BlockDescription = ({ children }: { children: ReactNode }) => {
    return <div className={`ContinueDealerOffer__Block__Description`}>{children}</div>;
};

const BlockCta = ({ label, handleClick }: { label: string; handleClick: () => void }) => {
    return (
        <SecondaryButton onClick={handleClick} className={`ContinueDealerOffer__Block__CTA`}>
            {label}
        </SecondaryButton>
    );
};

export { BlockContainer, BlockHeader, BlockDescription, BlockCta };
